<div [formGroup]="inputFormGroup">
    <div class="form-list clearfix" [formArrayName]="inputFormFieldKey">
        <div
            class="form-list-entry"
            *ngFor="let control of formArray?.controls; index as i; let first = first; let last = last"
        >
            <div class="form-list-sort">
                <terra-button
                    [inputIcon]="'icon-collapse_up'"
                    [inputIsDisabled]="first"
                    (outputClicked)="_moveElement(i, -1)"
                >
                </terra-button>
                <terra-button
                    [inputIcon]="'icon-collapse_down'"
                    [inputIsDisabled]="last"
                    (outputClicked)="_moveElement(i, 1)"
                >
                </terra-button>
            </div>
            <terra-form-entry
                *ngIf="!inputFormField.children"
                [formControlName]="i"
                [inputFormControl]="control"
                [inputFormField]="inputFormField"
                [inputControlTypeMap]="inputControlTypeMap"
                [inputIsDisabled]="inputIsDisabled"
            >
            </terra-form-entry>

            <terra-form-container
                *ngIf="inputFormField.children"
                [formGroupName]="i"
                [inputFormFields]="inputFormField.children"
                [inputFormGroup]="control"
                [inputScope]="_childScopes[i]"
                [inputControlTypeMap]="inputControlTypeMap"
                [inputIsDisabled]="inputIsDisabled"
                [width]="width"
                [horizontal]="inputFormField.type === 'horizontal'"
            ></terra-form-container>

            <terra-button
                [inputIcon]="'icon-delete'"
                [inputTooltipText]="'terraDynamicForm.removeListEntry' | translate: _locale.language"
                [inputIsDisabled]="!_canRemoveElement"
                (outputClicked)="_removeElement(i)"
            >
            </terra-button>
        </div>
        <terra-button
            [inputIcon]="'icon-add'"
            [inputTooltipText]="'terraDynamicForm.addListEntry' | translate: _locale.language"
            [inputIsDisabled]="!_canAddElement"
            (outputClicked)="_addElement()"
        >
        </terra-button>
    </div>
</div>
